import {fetchListings} from "@monterosa-sdk/interact-kit";

export default async function createFormattedEmbed(rootElement) {

  const { project } = await fetchListings(
    'cdn.monterosa.cloud',
    rootElement.dataset.projectId,
);

  const embedUrl = project ? project.embed : '';

  const formattedEmbedUrl = embedUrl
  .replace(/^\/\//, 'https://')
  .replace(/\?.*$/, '');

  try {
    const url = new URL(formattedEmbedUrl);

    // Map partner domains → unified apps domain
    if (
      url.hostname.includes('bundesliga.com')
    ) {
      url.hostname = 'apps.monterosa.cloud';
    }

    return url.toString();
  } catch (err) {
    throw new Error('Invalid embed Url');
  }
}